import PropTypes from 'prop-types';

function MMPantryInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11300)">
                <path
                    d="M8.16388 13.907C7.5707 13.6864 6.9396 13.5858 6.30724 13.6111C5.67487 13.6364 5.05383 13.7871 4.48016 14.0543C3.65182 14.4844 2.40134 15.3685 2.65224 15.7548C2.90313 16.1411 4.20537 16.3243 3.77129 17.3199C3.33721 18.3155 3.77129 18.6978 4.46423 18.9129C4.75086 18.9917 4.9966 19.1769 5.15128 19.4308C5.30596 19.6847 5.35792 19.988 5.29655 20.2788C5.13327 20.7687 5.40408 22.0351 6.3041 22.0948C7.20412 22.1546 7.83732 23.186 7.87317 23.6878C7.90901 24.1896 8.05237 24.7511 8.7254 24.8467C9.39843 24.9422 11.9312 25.0139 11.9472 20.6293C11.9472 17.0451 15.1331 18.3474 15.9774 18.8053C16.8216 19.2633 19.8044 19.5142 20.6447 17.8376C21.485 16.161 19.4859 16.5752 19.3266 16.0177C19.1673 15.4601 20.1748 14.9583 19.8682 14.1897C19.5615 13.4211 18.6734 13.9428 18.4464 12.9671C18.2194 11.9915 19.1712 10.7848 18.1717 10.5777C17.1721 10.3706 16.7898 10.6773 16.4473 10.1795C16.1048 9.68166 16.288 8.89315 15.6508 8.41128C15.0136 7.92941 12.4211 9.12413 12.0029 11.2786C11.5848 13.4331 12.0826 14.4207 11.0631 14.8628C10.0436 15.3048 9.69711 14.4207 8.16388 13.907Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M8.51434 17.4035C8.51434 17.4035 8.78515 16.149 12.1582 16.5871C15.7066 17.045 15.9136 15.8384 15.9136 15.8384"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.6712 13.9066C14.6712 13.9066 13.4765 13.4725 12.0547 16.5629C10.5653 19.8205 9.43433 19.3506 9.43433 19.3506"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M27.2435 9.79682L16.8893 1.99928C16.5868 1.67777 16.2129 1.432 15.7977 1.28187C15.3826 1.13173 14.938 1.08145 14.4998 1.1351C12.8312 1.38599 11.7321 3.28161 12.0427 5.36839C12.1152 5.955 12.3117 6.51945 12.6194 7.02415C12.927 7.52886 13.3386 7.96224 13.8268 8.29546V8.29546L24.3881 16.2603C24.6845 16.5493 25.0419 16.768 25.4341 16.9004C25.8264 17.0327 26.2433 17.0753 26.6541 17.0249C28.3228 16.774 29.4418 14.8784 29.1113 12.7916C29.0422 12.1849 28.8387 11.6013 28.5156 11.0833C28.1925 10.5652 27.7579 10.1257 27.2435 9.79682V9.79682Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M15.6402 8.69569C17.3087 8.44692 18.4089 6.55231 18.0976 4.46395C17.7862 2.37559 16.1812 0.884301 14.5127 1.13307C12.8442 1.38183 11.744 3.27645 12.0553 5.36481C12.3667 7.45317 13.9717 8.94445 15.6402 8.69569Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1558 4.85498L29.1273 12.78"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.9327 6.53564L29.1033 14.3173"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.3155 7.69824L28.5777 15.6869"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.4672 8.66602L27.4746 16.5631"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M25.2007 18.7812C25.7861 19.1795 27.4627 21.1428 27.6379 23.1261C27.8131 25.1093 27.3472 27.9049 25.3042 28.789C23.2612 29.6731 20.3581 30.7006 17.3075 27.7377C16.5673 27.0611 15.8902 26.3187 15.2845 25.5195C15.6827 25.5195 19.2669 22.8274 19.2669 22.8274C19.2669 22.8274 20.9315 24.8186 22.0546 24.5279C23.1776 24.2371 22.4926 22.4769 21.4453 21.2503C22.2975 20.2786 25.2007 18.7812 25.2007 18.7812Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M23.9883 21.173C25.0682 20.5495 25.6719 19.5731 25.3364 18.9921C25.001 18.4112 23.8536 18.4457 22.7736 19.0692C21.6936 19.6928 21.09 20.6692 21.4254 21.2501C21.7608 21.8311 22.9083 21.7966 23.9883 21.173Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.9054 25.2345C19.0388 24.5801 19.6856 23.5788 19.3502 22.9978C19.0148 22.4169 17.8241 22.4763 16.6908 23.1307C15.5575 23.785 14.9106 24.7864 15.246 25.3673C15.5815 25.9483 16.7721 25.8888 17.9054 25.2345Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11300">
                    <rect width="30" height="30" fill="white" transform="translate(0.894531 0.194336)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default MMPantryInactive;

MMPantryInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

MMPantryInactive.defaultProps = {
    className: null,
    width: 28,
};
